import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2'

// /** 获取巡检单 */
// export const getAllOnSiteInspection = () => {
//   return axios.get(`${rootApi}/production/workOrder/getPatrolCode`)
// }

// /** 获取完工检单 */
// export const getAllFinishInspection = () => {
//   return axios.get(`${rootApi}/production/workOrder/getFinishedCode`)
// }

/** 获取检验单 */
// export const getAllFirstInspection = () => {
//   return axios.get(`${rootApi}/production/workOrder/getWorkOrderByTime`)
// } 

/** 获取首件检产线 */
export const getFirstLineInspect = (params) => {
  return axios.get(`${rootApi}/stationAssemblyLineInspect/checkProcessFlowOrderWithInspect`,{params})
}

/** 获取未检验的所有流转卡 */
export const getNotInspectedList = (params) => {
  return axios.get(`${rootApi}/stationAssemblyLineInspect/getNotInspectedList`,{params})
}